import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-static-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './static-text.component.html',
  styleUrl: './static-text.component.scss',
})
export class StaticTextComponent {
  /** Left card headline (no longer baked into Concept card.svg — avoids stale/cached artwork). */
  readonly missionHeadline =
    'Shaping the Future through Grass-root Innovation with AI-Driven Solutions.';

  /** Main mission paragraph beside the card. */
  readonly missionDescription =
    'The National Health Authority (NHA) is the apex body responsible for implementing India’s flagship public health assurance scheme, Ayushman Bharat Pradhan Mantri Jan Arogya Yojana (AB PM-JAY), and has been entrusted with the role of designing strategy, building technological infrastructure, and implementing the Ayushman Bharat Digital Mission to create a National Digital Health Ecosystem.';
}
